import { ErrorResolutionTypes } from '../../../app/common/errorResolution/errorResolution';
import { ICard } from './card/card.interface';
import { CardsAction, CardsActionType } from './cardsActionType';
import { ICardsState } from './cardsState';

export function cardsReducer(
    state: ICardsState = {
        cardsMap: {},
        formOpen: false,
        loading: false,
    },
    action: CardsAction,
) {
    let payload: any;
    let cardsMap: { [cardToken: string]: ICard } = {};

    switch (action.type) {
        case CardsActionType.ADD_CARD_REQUEST:
        case CardsActionType.GET_CARDS_REQUEST:
        case CardsActionType.REMOVE_CARD_REQUEST:
        case CardsActionType.UPDATE_CARD_REQUEST:
            payload = action.payload;
            return {
                ...state,
                loading: true,
            };

        case CardsActionType.ADD_CARD_FAILURE:
        case CardsActionType.GET_CARDS_FAILURE:
        case CardsActionType.REMOVE_CARD_FAILURE:
        case CardsActionType.UPDATE_CARD_FAILURE:
            payload = action.payload;
            const formOpenNewState =
                payload.errorResolution &&
                payload.errorResolution.type !== ErrorResolutionTypes.REDIRECTING
                    ? state.formOpen
                    : false;
            return {
                ...state,
                error: payload.error,
                formOpen: formOpenNewState,
                loading: false,
            };

        case CardsActionType.ADD_CARD_SUCCESS:
        case CardsActionType.UPDATE_CARD_SUCCESS:
            payload = action.payload;
            cardsMap = { ...state.cardsMap };
            cardsMap[payload.card.cardToken] = payload.card;
            return {
                ...state,
                cardsMap,
                formOpen: false,
                loading: false,
            };

        case CardsActionType.GET_CARDS_SUCCESS:
            payload = action.payload;
            cardsMap = {};
            payload.cards.map((card: ICard) => (cardsMap[card.cardToken] = card));
            return {
                ...state,
                cardsMap,
                error: undefined,
                loading: false,
            };

        case CardsActionType.REMOVE_CARD_SUCCESS:
            payload = action.payload;
            cardsMap = { ...state.cardsMap };
            delete cardsMap[payload.cardToken];
            return {
                ...state,
                cardsMap,
                loading: false,
            };

        case CardsActionType.SET_IS_PRIMARY:
            payload = action.payload;
            cardsMap = { ...state.cardsMap };
            if (typeof payload.isPrimary === 'boolean') {
                Object.keys(cardsMap).forEach((cardToken: string) => {
                    cardsMap[cardToken].isPrimary =
                        cardToken === payload.cardToken ? Boolean(payload.isPrimary) : false;
                });
            }
            return {
                ...state,
                cardsMap,
            };

        case CardsActionType.OPEN_CARD_FORM:
            return {
                ...state,
                formOpen: true,
            };

        case CardsActionType.CLOSE_CARD_FORM:
            return {
                ...state,
                formOpen: false,
            };

        default:
            return state;
    }
}
